import { useState } from "react";
import { PolicyType } from "shared";
import { useNavigate } from "react-router";
import { useIntercom } from "react-use-intercom";

import { Modal } from "../../../../common/Atoms/Modal";
import { Heading } from "../../../../common/Atoms/Typography/Heading";
import { Paragraph } from "../../../../common/Atoms/Typography/Paragraph";
import { useModal } from "../../../hooks/useModals";
import { Divider } from "../../../../common/Atoms/Divider";
import { Button } from "../../../../common/Atoms/Button";
import { useGetSelectedOrganisation } from "../../../hooks/useGetSelectedOrganisation";

export function OneOffLateFeeModal() {
  const { hide, state } = useModal(`oneOffLateFee`);
  const navigate = useNavigate();
  const currentOrg = useGetSelectedOrganisation();
  const { trackEvent } = useIntercom();
  const [selectedType, setSelectedType] = useState<PolicyType.LATE_FEE | PolicyType.STATEMENT_LATE_FEE | null>(null);

  function onSelectLateFee() {
    setSelectedType(PolicyType.LATE_FEE);
    navigate(`${currentOrg.id}/invoices`);
  }

  function onSelectStatementLateFee() {
    setSelectedType(PolicyType.STATEMENT_LATE_FEE);
    navigate(`${currentOrg.id}/contacts/manage`);
  }

  function onHide() {
    if (selectedType) {
      trackEvent(`newModalUsage`, {
        type: selectedType,
      });
    }

    setSelectedType(null);
    hide();
  }

  function renderContent() {
    if (!selectedType) {
      return (
        <div className={ `flex flex-col justify-center items-center` }>
          <Paragraph>
            { `Would you like to issue the late fee or interest charge against individual invoices or against a contact's account balance?` }
          </Paragraph>

          <div className={ `flex mt-4` }>
            <Button
              onClick={ onSelectLateFee }
              color={ `paidniceGreenOutline` }
            >
              { `Invoices` }
            </Button>
            <Button
              onClick={ onSelectStatementLateFee }
              className={ `ml-4` }
              color={ `paidniceGreenOutline` }
            >
              { `Contacts` }
            </Button>
          </div>
        </div>
      );
    }

    if (selectedType === PolicyType.LATE_FEE) {
      return (
        <div className={ `flex flex-col justify-center items-center space-y-4` }>
          <Paragraph>
            { `On this invoice page, you can select multiple invoices using the checkboxes then click "Apply Late Fees" in the top right.` }
          </Paragraph>

          <img
            src={ `/img/invoice-late-fee.png` }
            alt={ `Late Fee Example` }
          />
          <Button
            className={ `` }
            onClick={ onHide }
          >
            { `Got It!` }
          </Button>
        </div>
      );
    }

    if (selectedType === PolicyType.STATEMENT_LATE_FEE) {
      return (
        <div className={ `flex flex-col justify-center items-center space-y-4` }>
          <Paragraph>
            { `On this contact page, you can select multiple contacts using the checkboxes then click "Quick Actions" in the top right, followed by "Charge Contacts Interest"` }
          </Paragraph>

          <img
            src={ `/img/contact-late-fee.png` }
            alt={ `Contact Late Fee Example` }
          />
          <Button
            className={ `` }
            onClick={ onHide }
          >
            { `Got It!` }
          </Button>
        </div>
      );
    }

    return null;
  }

  return (
    <Modal
      open={ state }
      setOpen={ onHide }
      title={ `` }
      width={ `xl` }
    >
      <div>
        <Heading>
          { `New one-off late fee` }
        </Heading>
        <Paragraph
          variant={ `help` }
        >
          { `Use this tool to do a one-off late fee or interest charge. To setup automatic late fees, head to the "Group" page then create an Automation Policy.` }
        </Paragraph>
      </div>

      <Divider
        weight={ `light` }
        spacing={ `small` }
      />

      { renderContent() }
    </Modal>
  );
}
